import moment from 'moment-mini';

import { IPlaceholderRequest, IUpdatePlaceholderRequest, PlaceholderResponse } from '@joc/api-gateway';

export type PlaceholderFormValues = IPlaceholderRequest;

export type PlaceholderUpdatePayload = IUpdatePlaceholderRequest & Pick<IPlaceholderRequest, 'startDate' | 'endDate'>;

const mapDescriptionHtml = (description: string): string => {
	const body = document.createElement('body');
	body.innerHTML = description;

	return body.outerHTML;
};

export const mapPlaceholderFormToCreateRequest = (values: PlaceholderFormValues): IPlaceholderRequest => ({
	name: values.name.trim(),
	description: mapDescriptionHtml(values.description),
	imagePath: values.imagePath?.trim() || undefined,
	startDate: moment(values.startDate).startOf('day').toDate(),
	endDate: moment(values.endDate).endOf('day').toDate(),
});

export const mapPlaceholderFormToUpdateRequest = (values: PlaceholderFormValues): PlaceholderUpdatePayload =>
	mapPlaceholderFormToCreateRequest(values);

export const getPlaceholderFormInitialValues = (placeholder?: PlaceholderResponse): PlaceholderFormValues => ({
	name: placeholder?.name || '',
	description: placeholder?.description || '',
	imagePath: placeholder?.imagePath || '',
	startDate: placeholder?.startDate || moment().startOf('day').toDate(),
	endDate: placeholder?.endDate || moment().add(1, 'day').startOf('day').toDate(),
});
